import { InternationalizationState } from './internationalization/types';
import { PermissionState } from './permissions/types';
import { OrganizationState } from './organization/types';
import { StructureState } from './structure/types';
import { FlowchartState } from './flowchart/types';
import { UserState } from './users/types';
import { MemberState } from './members/types';
import { GroupState } from './groups/types';
import { WorkflowState } from './workflows/types';
import { WidgetState } from './widgets/types';
import { ReportState } from './reports/types';
import { MyDataState } from './my-data/types';
import { StaticDataHolderState } from './static-info/types';
import { EventState } from './events/types';
import { ErrorState } from './errors/types';
import { PackageState } from './package/types';

export interface ApplicationState {
    internationalization: InternationalizationState,
    permissions: PermissionState,
    organization: OrganizationState,
    structure: StructureState,
    flowchart: FlowchartState,
    users: UserState,
    members: MemberState,
    groups: GroupState,
    workflows: WorkflowState,
    widgets: WidgetState,
    staticInfo: StaticDataHolderState,
    reports: ReportState,
    myData: MyDataState,
    events: EventState,
    errors: ErrorState,
    packages: PackageState,
}

export const FETCH_LOCAL_DATA_REQUEST = 'FETCH_LOCAL_DATA_REQUEST';
export const FETCH_LOCAL_DATA = 'FETCH_LOCAL_DATA';
export const RESET_SESSION = 'RESET_SESSION';

export interface FetchLocalDataRequestAction {
    type: typeof FETCH_LOCAL_DATA_REQUEST,
};

export interface FetchLocalDataAction {
    type: typeof FETCH_LOCAL_DATA,
    data: ApplicationState,
};

export interface ResetSessionAction {
    type: typeof RESET_SESSION,
};

export type GlobalActions = FetchLocalDataRequestAction | FetchLocalDataAction | ResetSessionAction;